import React, { Suspense, lazy, useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "./PressReleaseSection.css";

const EventHighlightsCarousel = lazy(() => import("../EventHighlightsCarousel/HighlightsCarousel"));
const PresentationCarousel = lazy(() => import("../PresentationCarousel/PresentationCarousel"));

const PressReleaseSection = () => {



  const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 767);
      };
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

    return isMobile;
  };

  const isMobile = useIsMobile();


  const imgCDNURL = process.env.REACT_APP_CDN_LINK + "ussaic/";

  const pressItems = [
    {
      id: 1,
      url: "https://nationalmortgageprofessional.com/news/housing-economic-leaders-embrace-new-digital-opportunities",
      image: imgCDNURL + "PressReleaseSection/nmp-housing.webp",
      alt: "NMP Digital Housing"
    },
    {
      id: 2,
      url: "https://www.morningstar.com/news/accesswire/1048157msn/angelai-hosts-landmark-us-strategy-for-ai-crypto-summit-at-the-national-press-club-and-attends-senate-hearing-on-digital-market-assets",
      image: imgCDNURL + "PressReleaseSection/angelai-pressclub.webp",
      alt: "AngelAi Press Club"
    }
  ];

  const responsiveCarousel = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 2,
    },
    tablet: {
      breakpoint: { max: 1024, min: 768 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 767, min: 0 },
      items: 1.2
    }
  };

  return (
    <div className="press-release-section">
      <div className="press-release-div">
            <p className="press-release-div-text">In The Press</p>
         </div>
      <Container className="press-release-container">
      
        

          <Carousel
            responsive={responsiveCarousel}
            swipeable={isMobile}
            draggable={isMobile}
            showDots={false}
            arrows={false} // Optional: you can keep arrows for desktop/tablet
            infinite={isMobile}
            keyBoardControl
            containerClass="press-carousel-container"
            itemClass="press-carousel-item"
          >
            {pressItems.map((item) => (
              <div key={item.id} className="press-release-card">
                <a href={item.url} target="_blank" rel="noopener noreferrer">
                  <img
                    src={item.image}
                    alt={item.alt}
                    className="press-release-image"
                  />
                </a>
              </div>
            ))}
          </Carousel>

        
      </Container>
      <div className="press-release-changes">
        <Suspense fallback={<div />}>
          <PresentationCarousel />
        </Suspense>
      </div>

      <div className="press-release-newchanges">
        <Suspense fallback={<div />}>
          <EventHighlightsCarousel />
        </Suspense>
      </div>
    </div>
  );
};

export default PressReleaseSection;
